import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function FundsAssetManagementLicenseMauritius() {

    return (
        <main className='main'>
            <IntroSection
                title="Funds & Asset Management License – Mauritius"
                subtitle="Launch Private Equity, Hedge Funds & Investment Firms in a Tier-1 IFC"
                description="Mauritius has earned its place as a global fund and asset management hub, serving as a bridge between Africa, India, and Asia. Under FSC regulation, fund promoters can establish Collective Investment Schemes (CIS), Closed-End Funds (CEFs), and Fund Manager/Administrator licenses. Mauritius’ credibility, combined with its tax treaty network, makes it the top choice for institutional investors, family offices, and asset managers."
                badges={[
                    "Private Equity Funds",
                    "Hedge Funds",
                    "Mutual Funds",
                    "Fund Managers"
                ]}
                buttonText="Request a Mauritius Fund Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt="Mauritius Funds & Asset Management"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Mauritius for Funds?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Tier-1 Fund Jurisdiction",
                                                text: "Globally recognized and OECD-compliant."
                                            },
                                            {
                                                title: "Double Tax Treaties",
                                                text: "40+ DTTs, especially with India & Africa."
                                            },
                                            {
                                                title: "Flexible Fund Structures",
                                                text: "Public, private, professional, and closed-end funds."
                                            },
                                            {
                                                title: "Lower Costs",
                                                text: "More affordable than Luxembourg, but credible."
                                            },
                                            {
                                                title: "Global Access",
                                                text: "Used by PE, VC, hedge funds, and institutional investors."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Fund Licenses in Mauritius"
                        blocks={[
                            {
                                title: "Collective Investment Scheme (CIS)",
                                items: [
                                    { text: "For retail/public mutual funds." },
                                    { text: "Requires custodian, administrator, and prospectus approval." },
                                    { text: "Capital Requirement: USD 100,000+." }
                                ]
                            },
                            {
                                title: "Professional CIS",
                                items: [
                                    { text: "For sophisticated and institutional investors only." },
                                    { text: "Lower regulatory burden and fast-track approval." },
                                    { text: "Capital Requirement: USD 25,000–50,000." }
                                ]
                            },
                            {
                                title: "Closed-End Funds (CEFs)",
                                items: [
                                    { text: "For private equity, venture capital, and long-term investment funds." },
                                    { text: "Flexible structure with institutional investors." },
                                    { text: "Capital Requirement: USD 50,000+." }
                                ]
                            },
                            {
                                title: "Fund Manager License",
                                items: [
                                    { text: "Authorizes portfolio and fund management activities." },
                                    { text: "Can manage CIS, CEFs, and institutional accounts." },
                                    { text: "Capital Requirement: USD 35,000+." }
                                ]
                            },
                            {
                                title: "Fund Administrator License",
                                items: [
                                    { text: "Covers fund administration, accounting, and compliance reporting." },
                                    { text: "Often bundled with Fund Manager License." },
                                    { text: "Capital Requirement: USD 35,000+." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Funds",
                                    text: "USD 25,000–100,000 depending on type."
                                },
                                {
                                    title: "Managers/Admins",
                                    text: "USD 35,000+."
                                },
                                {
                                    title: "Entity Requirement",
                                    text: "Global Business Company (GBC) required."
                                },
                                {
                                    title: "Resident Presence",
                                    text: "Local office, compliance officer, and resident directors."
                                },
                                {
                                    title: "Custodian",
                                    text: "Mandatory for CIS (public funds)."
                                },
                                {
                                    title: "AML/KYC Compliance",
                                    text: "Required by FSC."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Mauritius Fund License'
                        services={
                            [
                                {
                                    title: "High Recognition",
                                    text: "Trusted by investors in Africa, India, and globally."
                                },
                                {
                                    title: "Treaty Network",
                                    text: "Over 40 Double Taxation Treaties."
                                },
                                {
                                    title: "Flexible Structures",
                                    text: "Supports retail, professional, private equity, and hedge funds."
                                },
                                {
                                    title: "Banking & Custody",
                                    text: "Access to Tier-1 banks and custodians."
                                },
                                {
                                    title: "Cost-Effective",
                                    text: "Cheaper than EU hubs but still Tier-1 credible."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Define fund type: CIS, CEF, PE, or hedge."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Set up a Mauritius GBC."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Prospectus (for public funds), AML/KYC, and financials."
                                },
                                {
                                    title: "FSC Review",
                                    text: "Regulator conducts due diligence on promoters & directors."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically completed in 3–6 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "3–6 months",
                            },
                            {
                                name: "Setup Costs",
                                description: "From USD 50,000+ (legal, compliance, licensing)",
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 25k–100k depending on fund type",
                            },
                            {
                                name: "Annual Costs",
                                description: "Audits, FSC fees, custodian fees (for CIS)",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Specialists in fund structuring & licensing."
                                },
                                {
                                    text: "Full-service: incorporation, FSC filings, compliance, custodians."
                                },
                                {
                                    text: "Network of prime brokers, custodians, and administrators."
                                },
                                {
                                    text: "Comparative insights: Mauritius vs Malta vs Luxembourg vs Cayman."
                                },
                                {
                                    text: "Ongoing compliance & reporting support."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a hedge fund, private equity fund, or investment firm?"
                        description="Mauritius offers fund & asset management licenses under FSC, with global recognition and tax treaty benefits."
                        buttonText="Book a Mauritius Fund License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the most popular fund structure in Mauritius?",
        content: [
            { type: "answer", text: "Professional CIS and CEFs (used for hedge funds & PE)." },
        ],
    },
    {
        question: "Do Mauritius funds qualify for tax treaties?",
        content: [
            { type: "answer", text: "Yes — GBC funds benefit from 40+ DTTs." },
        ],
    },
    {
        question: "Do I need a custodian for a Mauritius fund?",
        content: [
            { type: "answer", text: "Yes — mandatory for retail/public CIS, optional for private/professional funds." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "3–6 months." },
        ],
    },
    {
        question: "Why Mauritius over Seychelles?",
        content: [
            { type: "answer", text: "Mauritius has higher recognition, treaty access, and investor trust." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We established a private equity fund in Mauritius. Offshore Advisory managed FSC licensing and introduced us to a custodian.",
        author: "Jonathan M.",
        role: "Fund Manager"
    },
    {
        quote: "Mauritius was the right choice for our hedge fund. Offshore Advisory handled setup and FSC compliance efficiently.",
        author: "Elena R.",
        role: "Hedge Fund Founder"
    }
];
